export default __webpack_public_path__ + "static/media/comingsoon.cec104c9.jpg";